/* eslint-disable no-fallthrough, import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { PopoverProps } from 'components/popover';
// eslint-disable-next-line no-restricted-imports
import { POPOVER_NAME as BOARDS_MENU_POPOVER } from 'components/popovers/boards-menu/boards-menu';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import {
  closePopover,
  closePopovers,
  CollapsiblesState,
  createBoardSetNameFromSearch,
  loadBoardsForBoardsMenu,
  OverlayType,
  preloadCreateBoardData,
  setBoardsMenuScrollPosition,
  setBoardsMenuSelectedBoard,
  setOverlay,
  showPopover,
  State,
  toggleAlwaysOpenBoardsMenu,
  toggleBoardsMenu,
  updateSidebarState,
} from 'modules';
// eslint-disable-next-line no-restricted-imports
import { MemberContext } from 'modules/context';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// eslint-disable-next-line no-restricted-imports
import {
  getBoardsMenu,
  getBoardsMenuCategoriesWithBoards,
  getBoardsMenuFilteredBoards,
  getBoardsMenuSearchText,
  getCollapsedDrawerSections,
  getMyId,
  isBoardsMenuPinned,
  isLoggedIn,
  isPopoverShown,
} from 'selectors';
// eslint-disable-next-line no-restricted-imports
import {
  BoardModel,
  BoardsMenuCategoryModel,
  BoardsMenuSelectedItemModel,
} from 'types/models';
import BoardsMenu from './boards-menu';

interface StateProps {
  readonly isBoardsMenuPopoverOpen: boolean;
  readonly alwaysOpenBoardsMenu: boolean;
  readonly categoriesWithBoards: BoardsMenuCategoryModel[];
  readonly visibleBoards: BoardsMenuSelectedItemModel[] | null;
  readonly filteredBoards: BoardModel[] | null;
  readonly idMe: string;
  readonly isLoggedIn: boolean;
  readonly isSearching: boolean;
  readonly selectedBoard: BoardsMenuSelectedItemModel | null;
  readonly loading: boolean;
  readonly scrollPosition: number;
  readonly searchText: string;
}

interface DispatchProps {
  readonly dispatch: Dispatch<State>;
  readonly onClose: (trackingMethod: string) => void;
  readonly setBoardsMenuScrollPosition: (position: number) => void;
  readonly showCreateBoard: () => void;
  readonly toggleAlwaysOpenBoardsMenu: (alwaysOpenBoardsMenu: boolean) => void;
  readonly toggleClosedBoardDialog: () => void;
  readonly setSelectedBoard: (
    selected: BoardsMenuSelectedItemModel | null,
  ) => void;
}

interface OwnProps {
  readonly target?: PopoverProps['target'];
}

interface AllLegacyProps extends StateProps, DispatchProps, OwnProps {}

class BoardsMenuContainer extends React.Component<AllLegacyProps> {
  loader = (prevProps = { idMe: '' }) => {
    const { dispatch, idMe } = this.props;

    if (idMe && idMe !== prevProps.idMe) {
      dispatch(updateSidebarState());
      dispatch(loadBoardsForBoardsMenu(idMe));
      dispatch(preloadCreateBoardData());
    }
  };

  componentDidMount() {
    this.loader();
  }

  componentDidUpdate(prevProps: AllLegacyProps) {
    this.loader(prevProps);
  }

  render() {
    return (
      <MemberContext.Provider value={{ id: this.props.idMe }}>
        <BoardsMenu {...this.props} />
      </MemberContext.Provider>
    );
  }
}

const mapStateToProps = (state: State): StateProps => {
  const isBoardsMenuPopoverOpen = isPopoverShown(state, BOARDS_MENU_POPOVER);
  const searchText = getBoardsMenuSearchText(state);
  const isSearching = !!searchText;
  const categoriesWithBoards = getBoardsMenuCategoriesWithBoards(state);
  const filteredBoards = isSearching
    ? getBoardsMenuFilteredBoards(state)
    : null;
  const collapsables: CollapsiblesState = getCollapsedDrawerSections(state);
  const visibleCategoryBoards:
    | BoardsMenuSelectedItemModel[]
    | null = !isSearching
    ? categoriesWithBoards
        .filter(
          (category: BoardsMenuCategoryModel) =>
            collapsables[category.id] ? collapsables[category.id].open : true,
        )
        .reduce(
          (
            result: BoardsMenuSelectedItemModel[],
            category: BoardsMenuCategoryModel,
          ) => {
            const items: BoardsMenuSelectedItemModel[] = category.boards.map(
              (board: BoardModel) => ({
                id: board.id,
                category: category.id,
                url: board.url,
              }),
            );

            return result.concat(items);
          },
          [],
        )
    : null;

  const visibleFilteredBoards: BoardsMenuSelectedItemModel[] | null =
    isSearching && filteredBoards
      ? filteredBoards.map((board: BoardModel) => ({
          id: board.id,
          category: null,
          url: board.url,
        }))
      : null;

  const visibleBoards = isSearching
    ? visibleFilteredBoards
    : visibleCategoryBoards;

  return {
    categoriesWithBoards,
    visibleBoards,
    filteredBoards,
    selectedBoard: getBoardsMenu(state).selectedBoard,
    alwaysOpenBoardsMenu: getBoardsMenu(state).alwaysOpenBoardsMenu,
    idMe: getMyId(state),
    isLoggedIn: isLoggedIn(state),
    isBoardsMenuPopoverOpen,
    scrollPosition: getBoardsMenu(state).scrollPosition,
    isSearching: !!searchText,
    searchText,
    loading: getBoardsMenu(state).loading,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<object>): DispatchProps => ({
  dispatch,

  setBoardsMenuScrollPosition(position: number) {
    dispatch(setBoardsMenuScrollPosition(position));
  },

  showCreateBoard() {
    Analytics.trackUE({
      category: Noun.BOARDS_MENU,
      verb: Verb.OPENS,
      directObj: Noun.CREATE_BOARD_MODAL,
    });
    dispatch(preloadCreateBoardData());
    dispatch(createBoardSetNameFromSearch());
    dispatch(setOverlay(OverlayType.CreateBoard));
    dispatch(closePopovers());
  },

  toggleAlwaysOpenBoardsMenu(alwaysOpenBoardsMenu: boolean) {
    dispatch(toggleAlwaysOpenBoardsMenu());
    dispatch(toggleBoardsMenu());
    if (alwaysOpenBoardsMenu) {
      // if we're toggling off the alwaysOpenBoardsMenu value, open the popover
      dispatch(showPopover({ name: BOARDS_MENU_POPOVER }));
    }
    Analytics.trackUE({
      category: Noun.BOARDS_MENU,
      verb: alwaysOpenBoardsMenu ? Verb.DISABLES : Verb.SUBMITS,
      directObj: Noun.ALWAYS_OPEN_MENU_DEFAULT,
    });
  },

  toggleClosedBoardDialog() {
    dispatch(closePopovers());
    dispatch(setOverlay(OverlayType.ClosedBoards));
    Analytics.trackUE({
      category: Noun.BOARDS_MENU,
      verb: Verb.SHOWS,
      directObj: Noun.CLOSED_BOARDS,
    });
  },

  setSelectedBoard(selected: BoardsMenuSelectedItemModel | null) {
    dispatch(setBoardsMenuSelectedBoard(selected));
  },

  onClose(trackingMethod = '') {
    dispatch(closePopover(BOARDS_MENU_POPOVER));
    dispatch(toggleBoardsMenu());

    Analytics.trackUE({
      category: Noun.HEADER,
      verb: Verb.CLOSES,
      directObj: Noun.BOARDS_MENU,
      method: trackingMethod,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    areStatesEqual(next, prev) {
      switch (true) {
        // If the menu is and will remain hidden…
        case !isPopoverShown(next, BOARDS_MENU_POPOVER) &&
          !isPopoverShown(prev, BOARDS_MENU_POPOVER) &&
          !isBoardsMenuPinned(next) &&
          !isBoardsMenuPinned(prev):
          // skip re-rendering
          return true;

        // else if any underlying models change…
        case next.models !== prev.models:
        // or if the UI state of the boards menu has changed…
        case next.ui.boardsMenu !== prev.ui.boardsMenu:
        // or if the boards menu popover has opened/closed…
        case isPopoverShown(next, BOARDS_MENU_POPOVER) !==
          isPopoverShown(prev, BOARDS_MENU_POPOVER):
          // …assume we need to update.
          return false;

        default:
          // Otherwise, skip re-rendering as building the boards list is expensive
          return true;
      }
    },
  },
)(BoardsMenuContainer);



// WEBPACK FOOTER //
// ./app/gamma/src/components/popovers/boards-menu/index.tsx